import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AboutCtaSectionConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-about-cta-section',
  standalone: false,
  templateUrl: './about-cta-section.component.html',
  styleUrls: ['./about-cta-section.component.scss']
})
export class AboutCtaSectionComponent {
  @Input() section: AboutCtaSectionConfig | null = null;
}
